import {gql} from '@apollo/client';
import {useMemo} from 'react';

import {BenchlingQueryResult, QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {SchemaSSIsQuery} from 'schemas/util/__generated/SchemaSSIsQuery';

export const SCHEMA_SSIS_QUERY = gql`
  query SchemaSSIsQuery @skipAudit @engComponent(name: REGISTRY) {
    tagSchemas {
      id
      interfaceConfigs {
        interface {
          id
          ... on StaticSchemaInterfaceNode {
            id
          }
        }
      }
    }
  }
`;

export interface UseSchemaSSIsByIdQueryResult {
  interfaceIdsBySchemaId: Record<string, Array<string>>;
  status: BenchlingQueryResult<SchemaSSIsQuery>;
}

export default function useSchemaSSIsByIdQuery(): UseSchemaSSIsByIdQueryResult {
  const result = useBenchlingQuery<SchemaSSIsQuery>(SCHEMA_SSIS_QUERY);

  const interfaceIdsBySchemaId = useMemo(() => {
    if (result.type !== QueryResultType.SUCCESS) {
      return {};
    }
    return Object.fromEntries(
      result.data.tagSchemas.map((schema) => [
        schema.id,
        schema.interfaceConfigs.map((config) => config.interface.id),
      ])
    );
  }, [result]);

  return {
    interfaceIdsBySchemaId,
    status: result,
  };
}
